import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { ValidationDetail } from '../validation-detail';
import { PauseBuilder } from './pause.builder';

export class ValidationDetailBuilder {
  static fromJson(json) {
    return (json)
      ? new ValidationDetail(
        json.hash,
        parseNumber(json.startTime),
        parseNumber(json.endTime),
        parseNumber(json.realTime),
        parseNumber(json.maxRealTime),
        json.alarm,
        json.subactivityHash,
        json.subactivityName,
        json.programHash,
        json.programReference,
        parseNumber(json.programTime),
        json.programTool,
        json.printHash,
        json.printReference,
        json.manufacturingOrderHash,
        json.manufacturingOrderCode,
        json.materialHash,
        json.materialCode,
        json.materialFileName,
        json.partHash,
        json.partName,
        json.alarms,
        json.stop,
        json.alarmStopped,
        json.maintenance,
        json.preparation,
        json.editable,
        json.execution,
        parseNumber(json.minRealTime),
        PauseBuilder.fromList(json.pauses)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ValidationDetailBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/validation-detail.builder.ts